import React from 'react';

import { Props as LinkProps } from 'Elements/Link';

import Grid, { Col } from 'Components/Grid';

import {
    Container,
    Heading,
    StyledIcon,
    Description,
    Text,
    DescriptionLink
} from './InfoBar.styled';

export interface Props {
    heading: string;
    text: React.ReactNode;
    link?: LinkProps;
    icon?: React.ElementType;
    backgroundColour?: string;
    textColour?: string;
}

const InfoBar: React.FC<Props> = ({ heading, text, icon, link, backgroundColour, textColour }) => {
    return (
        <Container
            id="information-bar"
            style={
                {
                    '--infoBar-bg-colour': backgroundColour,
                    '--infoBar-txt-colour': textColour
                } as React.CSSProperties
            }
        >
            <Grid>
                <Col m={6} align="center">
                    <Heading $withIcon={icon ? true : false}>
                        {icon && <StyledIcon as={icon} />}
                        {heading}
                    </Heading>
                </Col>
                <Col m={6} align="center">
                    <Description>
                        {link && <DescriptionLink variant="fourDark" {...link} />}
                        <Text>{text}</Text>
                    </Description>
                </Col>
            </Grid>
        </Container>
    );
};

export default InfoBar;
